import { useCallback, useEffect, useState } from 'react';
import { useTrialsContext } from 'contexts/TrialsContextProvider';
import useScript from 'hooks/useScript';
import { useTracking } from '@podiumhq/tracking';
import { createCookie } from "../../lib/getIdToken";
import env from 'env';

const SignInWithGoogle = ({onLogin}) => {
    const {
        checkEmailAddressExists,
        checkForInvite,
        email,
        setEmail,
        setFirstName,
        setThirdPartyJwt,
        setLastName,
    } = useTrialsContext() || {};
    const { trackEvent } = useTracking();
    const [refresh, setRefresh] = useState(0);
    const [loginSuccess, setLoginSuccess] = useState(false);
    const [loaded, setLoaded] = useState(false);
    const [enabled, setEnabled] = useState(false);
    const status = useScript({ src: env.GOOGLE_ACCOUNT_URI });

    const handleLogin = useCallback(async ({credential}) => {
        document.cookie = createCookie({cookieName: 'gToken', cookieValue: credential, hostname: window.location.hostname});
        setThirdPartyJwt({source: 'google', jwt: credential});
        const tokenParts = credential.split(".");
        const token = atob(tokenParts[1]);
        const {email, given_name, family_name} = JSON.parse(token);
        await checkForInvite(email);
        checkEmailAddressExists(email)
            .then((exists) => {
                if(exists) {
                    trackEvent('trials.googleLogin.redirectExisting');
                    window.location.assign(env.ACCOUNTS_URL);
                }
                else {
                    setEmail(email);
                    setFirstName(given_name);
                    setLastName(family_name);
                    setLoginSuccess(true);
                }
            })
            .catch((error) => {
                trackEvent('trials.accountInfo.error', {
                    error: JSON.stringify(error),
                });
            });
    }, [
        trackEvent,
        setThirdPartyJwt,
        checkEmailAddressExists,
        checkForInvite,
        setEmail,
        setFirstName,
        setLastName,
        setLoginSuccess
    ]);

    const onClick = useCallback(() => {
        trackEvent('trials.googleLogin.clicked')
    }, [trackEvent]);

    useEffect(() => {
        const urlParams = new URLSearchParams(window.location.search);
        if (!urlParams.has('siwg')) return;
        if(!!env.GOOGLE_CLIENT_ID && !!env.GOOGLE_ACCOUNT_URI) {
            setEnabled(true);
        }
    }, [])

    useEffect(() => {
        if (loaded) return;
        if(status.loaded && !status.error) {
            setLoaded(true);
        }
    }, [status, loaded]);

    useEffect(() => {
        if(loginSuccess && !!email) {
            trackEvent('trials.googleLogin.succeeded');
            onLogin();
        }
    }, [loginSuccess, email, onLogin, trackEvent])

    useEffect(() => {
        if(loaded && enabled) {
            if(!!window?.google?.accounts) {
                window.google.accounts.id.initialize({
                    client_id: env.GOOGLE_CLIENT_ID,
                    callback: handleLogin
                });
                window.google.accounts.id.renderButton(
                    document.getElementById("signInWithGoogleButton"),
                    { theme: "outline", size: "large", text: "signup_with", width: 350, click_listener: onClick }
                );
            }
            else {
                setTimeout(() => {setRefresh(refresh + 1)}, 250)
            }
        }
    }, [loaded, refresh, enabled, handleLogin, onClick]);

    return enabled && (
        <div id="signInWithGoogleButton" style={{marginBottom: 32}}></div>
    )
};

export default SignInWithGoogle;
